import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0df8bae4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aboat" }
const _hoisted_2 = { class: "aboat-cen" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = { class: "conter" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_nav_bar, {
        title: $setup.t('me.gywm'),
        "left-arrow": "",
        onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.ToBack($setup.router)))
      }, null, 8 /* PROPS */, ["title"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: $setup.SVIP_ICON,
          class: "aboat-cen-logo",
          alt: ""
        }, null, 8 /* PROPS */, _hoisted_3),
        _createElementVNode("p", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString($setup.appname), 1 /* TEXT */)
        ]),
        _createElementVNode("p", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('版本')), 1 /* TEXT */),
          _createElementVNode("span", null, _toDisplayString(' ' + $setup.channelId + '.' + $setup.version), 1 /* TEXT */)
        ])
      ])
    ]),
    _createElementVNode("p", _hoisted_6, [
      _createTextVNode(_toDisplayString($setup.appname) + " " + _toDisplayString(_ctx.$t('me.abouttext1')) + " ", 1 /* TEXT */),
      _hoisted_7,
      _hoisted_8,
      _createTextVNode(" " + _toDisplayString($setup.appname) + " " + _toDisplayString(_ctx.$t('me.testx1')) + " ", 1 /* TEXT */),
      _hoisted_9,
      _hoisted_10,
      _createTextVNode(" " + _toDisplayString(_ctx.$t('me.wl1')) + " " + _toDisplayString($setup.appname) + " " + _toDisplayString(_ctx.$t('me.wlyt')), 1 /* TEXT */)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}